const colors = {
  white: {
    base: '#ffffff',
  },
  black: {
    base: '#000000',
  },
  sky: {
    lighter: '#f6f9fa',
    light: '#dde0e1',
    base: '#c5c7c8',
    dark: '#acaeaf',
  },
  ink: {
    lightest: '#a4a4a4',
    lighter: '#767676',
    light: '#494949',
    base: '#1b1b1b',
  },
  primary: {
    lightest: '#DDF1EB',
    base: '#17A680',
  },
}

export const theme = {
  primaryColor: '#17A680',
  colors,
  fontStack: '-apple-system, BlinkMacSystemFont, San Francisco, Roboto, Segoe UI, Helvetica Neue, sans-serif',
}



// WEBPACK FOOTER //
// ./src/theme.js